import * as React from 'react';
import {checkStock, getEnv, getHostApi} from '../../utils';
import { StockErrors } from '../cart/cartInterfaces';
import {getUserId} from "../mon-compte/MonCompteAction";

//eslint-disable-next-line
declare var paypal_sdk: any;

interface PaypalCheckoutProps {
  containerId?: string;
  cartId?: string;
  orderId?: string;
  style?: Record<string, unknown>;
  onPaymentRequested?: () => void;
  onPaymentApproved?: (data: any) => void;
  onPaymentConfirmed?: () => void;
  onPaymentCancel?: (data: any) => void;
  onPaymentError?: (data: any) => void;
  onStockError?(stockErrors: StockErrors): void;
}


export class PaypalCheckoutV2 extends React.Component<PaypalCheckoutProps, Record<string, unknown>> {

  private createUrl?: string;
  private executeUrl?: string;

  constructor(props: PaypalCheckoutProps) {
    super(props);

    if(this.props.cartId) {
      this.createUrl = `${getHostApi()}/carts/${this.props.cartId}/paypal/flow/create`;
    } else if (this.props.orderId) {
      const userId = getUserId();

      this.createUrl = `${getHostApi()}/customers/${userId}/orders/${this.props.orderId}/paypal/create`;
      this.executeUrl = `${getHostApi()}/customers/${userId}/orders/${this.props.orderId}/paypal/confirm`;
    }
  }

  private getContainerId() : string {
    if (!this.props.containerId) {
      return 'paypal-container';
    }

    return this.props.containerId;
  }

  componentDidMount() {
    const env = getEnv();

    const button: any = paypal_sdk?.Buttons({
      fundingSource: 'paypal',
      env: (env==='development' || env==='preprod')?'sandbox':'production', // sandbox | production
      // locale: 'fr_FR',
      style: {
        size: 'responsive',
        //color: (fundingSource=='card')?'white':'silver',
        color:'silver',
        shape: 'rect',
        label: 'pay',
        tagline: false
      },

      createOrder: () => {
        return checkStock(this.props.cartId || '')
          .then(() => {
            const headers = new Headers();
            headers.append("x-xsrf-token", localStorage.getItem('xsrfToken') || '0');

            return fetch(this.createUrl as string, {
              method: "POST",
              headers: headers,
              credentials: "include"
            }).then((res) => {
              return res.json();
            }).then(json => {
              return json.id;
            }).catch(err => {
              console.error(err);
            });
          }).catch(err => {
            if(this.props?.onStockError) {
              this.props.onStockError(err);
            }
          });
      },

      onApprove: (data: any) => {
        if (this.props.onPaymentApproved) {
          this.props.onPaymentApproved(data);
        }

        if (this.executeUrl) {
          const headers = new Headers();
          headers.append("x-xsrf-token", localStorage.getItem('xsrfToken') || '0');
          headers.append("Content-Type", "application/json");

          return fetch(this.executeUrl, {
            method: "POST",
            body: JSON.stringify(data),
            headers: headers,
            credentials: "include"
          }).then((res) => {
            return res.json();
          }).then(json => {
            if (this.props.onPaymentConfirmed) {
              this.props.onPaymentConfirmed();
            }
          }).catch(err => {
            console.error(err);
          });
        }
      },

      onError: (data: any) => {
        this.props.onPaymentError?.(data);
      },
    });

    if (button.isEligible()) {
      button.render(`#${this.getContainerId()}`);
    }
  }

  render() {
    return <div style={this.props.style} id={this.getContainerId()}/>;
  }
}
